// 针对大于等于1290的钥匙的keytype的转换方法
export function getKeyTypeByDeviceinfo(devicedata) {
  const support = devicedata.support || [];
  let type = 4; // 普通屏显钥匙
  if (support.length === 1) {
    if (support.includes('ble')) {
      type = 5;
    } else if (support.includes('finger')) {
      type = 6;
    } else if (support.includes('4g') || support.includes('cellular')) {
      type = 8;
    }
  } else if (support.length === 2) {
    if (support.includes('ble') && support.includes('finger')) {
      type = 7;
    } else if (
      support.includes('finger') &&
      (support.includes('4g') || support.includes('cellular'))
    ) {
      type = 9;
    } else if (
      support.includes('ble') &&
      (support.includes('4g') || support.includes('cellular'))
    ) {
      type = 10;
    }
  } else if (support.length === 3) {
    if (
      support.includes('finger') &&
      support.includes('ble') &&
      (support.includes('4g') || support.includes('cellular'))
    ) {
      type = 11;
    }
  }
  return type;
}

// 根据钥匙类型、钥匙版本号判断该钥匙是否支持多任务
export function isSuppoutMultiTask(keyInfo) {
  let isSupport = false;
  // 钥匙类型（device）说明：
  // 普通钥匙：1281、1285
  // 蓝牙钥匙：1282、1286
  // 指纹钥匙：1283、1287
  // 指纹蓝牙钥匙：1284、1288
  const { device, ver } = keyInfo;

  // 指纹钥匙：ver >= 257，支持多任务及任务模式转换
  if ((device === 1283 || device === 1287) && ver >= 257) {
    isSupport = true;
  }
  // 指纹蓝牙钥匙：ver >= 259，支持多任务及任务模式转换
  else if ((device === 1284 || device === 1288) && ver >= 259) {
    isSupport = true;
  }
  // 普通钥匙、蓝牙钥匙：ver === 261 || ver >= 516，支持多任务及任务模式转换
  else if (device === 1281 || device === 1282 || device === 1285 || device === 1286) {
    if (ver === 261 || ver >= 516) {
      isSupport = true;
    }
  }
  // EK系列钥匙，都支持多任务及任务模式转换
  else if (device >= 1290) {
    isSupport = true;
  }

  return isSupport;
}
